import React from 'react';
import AdminInvoiceTemplatePage from '../domains/billing/components/AdminInvoiceTemplatePage';

const AdminInvoiceTemplate: React.FC = () => {
  return <AdminInvoiceTemplatePage />;
};

export default AdminInvoiceTemplate;

